<template>
    <div>
        <Titulo titulo="AVISO DE PRIVACIDAD"/>

        <b-container class="mt-4 mb-5">

            <b-card 
                class="html-content-card"
                style="height: 500px; overflow-y: auto;"
            >
                <div v-html="aviso"></div>
            </b-card>

        </b-container>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
const axios = require('axios');
import {mapState} from 'vuex'

export default {
    name: 'AvisoPrivacidad',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            aviso: ''
        }
    },
    created() {
        this.traerAviso()
    },
    methods: {
        traerAviso() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "aviso_privacidad");
            formData.append("limite", 1);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.aviso = res.data.aviso.replace('<br />', '\n')
            });
        },
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>

</style>